import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavCollapseService {
  readonly isMobile$ = this.breakpointObserver.observe(['(max-width: 992px)']).pipe(map((breakpoint) => breakpoint.matches));
  // The sidebar collapses to icons only on mobile; there is no manual collapse toggle anymore.
  readonly collapse$ = this.isMobile$;

  private hoverNavigationSubject = new BehaviorSubject<boolean>(true);
  readonly hoverNavigation$ = combineLatest([this.hoverNavigationSubject.asObservable(), this.isMobile$]).pipe(
    map(([hoverNavigation, isMobile]) => hoverNavigation && isMobile)
  );

  constructor(private readonly breakpointObserver: BreakpointObserver) {}

  toggleMobileNavigation(): void {
    this.hoverNavigationSubject.next(!this.hoverNavigationSubject.getValue());
  }
}
